import {ComponentCanDeactivate} from '../../../core/can-deactivate/can-deactivate.component';


export abstract class PageCanDeactivate extends ComponentCanDeactivate {

  abstract get hasChanges() ;

  canDeactivate(): boolean {
    return !this.hasChanges;
  }
}



// WEBPACK FOOTER //
// ./src/app/rules/common/can-deactivate/can-deactivate-page.ts